import {
  INIT_PLUGIN_COMMS_CENTER,
  SET_AGENT_STATUS,
  REQUEST_CONTACT,
  REQUEST_CONTACT_SUCCESS,
  REQUEST_CONTACT_FAILURE,
  REQUEST_CONTACT_RESET,
  SOCKET_CONNECT_ANONYMOUS,
  SOCKET_CONNECT_SUCCESS,
  SOCKET_DISCONNECT,
  SOCKET_EVENT,
  SET_CUSTOMER_CHAT,
  INITIATE_REVIEW,
  FINISH_REVIEW,
  SEND_REVIEW,
  SEND_REVIEW_SUCCESS,
  SEND_REVIEW_FAILURE,
} from './actions';
import socketReducer from './socketReducer';
import { addSubreducers } from '../../redux/utils';
import { sortContacts } from './utils';

const subreducers = addSubreducers({
  socket: socketReducer,
});

function handleUserConnection(
  state,
  username,
  { isOnline, isMobileOnline, isAudioCallAvailable, isVideoCallAvailable }
) {
  const contacts = [...state.contact.list];
  const contactIndex = contacts.findIndex(entry => entry.id === username);
  const contact = { ...contacts[contactIndex] };
  contacts[contactIndex] = contact;
  if (typeof isOnline === 'boolean') {
    contact.is_online = isOnline;
  }
  if (typeof isMobileOnline === 'boolean') {
    contact.is_mobile_online = isMobileOnline;
  }
  if (typeof isAudioCallAvailable === 'boolean') {
    contact.is_audio_call_available = isAudioCallAvailable;
  }
  if (typeof isVideoCallAvailable === 'boolean') {
    contact.is_video_call_available = isVideoCallAvailable;
  }
  return { ...state, contact: { ...state.contact, list: sortContacts(contacts) } };
}
function handleSocketEvents(state, { payload: { eventName, args } }) {
  switch (eventName) {
    case 'user_connected':
      return handleUserConnection(state, args.username, {
        isOnline: true,
        ...(args.isMobile ? { isMobileOnline: true } : {}),
        isAudioCallAvailable: args.isAudioCallAvailable,
        isVideoCallAvailable: args.isVideoCallAvailable,
      });
    case 'user_disconnected':
      return handleUserConnection(state, args, { isOnline: false });
    case 'mobile_user_disconnected':
      return handleUserConnection(state, args, { isMobileOnline: false });
    case 'activated_agent':
      return { ...state, isAgent: true };
    case 'deactivated_agent':
      return { ...state, isAgent: false };
    // case 'chat_ended':
    //   return { ...state, isAnonymous: false, anonymous: null };
  }
  return state;
}

const initialState = {
  isAgent: false,
  isCenterActive: false,
  isAnonymous: false,
  anonymous: null,
  requestContact: {
    pending: false,
    response: '',
    succeeded: false,
    error: null,
  },
  customerChat: null,
  reviewData: null,
  reviewPending: false,
  reviewError: null,
};
export default (state = initialState, action) => {
  switch (action.type) {
    case 'HANDLE_LOGIN_FULFILLED':
    case 'FETCH_CREDENTIALS_FULFILLED':
      return {
        ...state,
        contact: { ...state.contact, list: [] },
        customerChat: null,
        anonymous: null,
        isAnonymous: false,
      };
    case 'HANDLE_LOGOUT_FULFILLED':
      return { ...state, customerChat: null, anonymous: null, isAnonymous: true };
    case SET_AGENT_STATUS:
      return { ...state, isAgent: action.payload };
    case INIT_PLUGIN_COMMS_CENTER:
      return { ...state, isCenterActive: true };
    case REQUEST_CONTACT:
      return { ...state, requestContact: { ...state.requestContact, succeeded: false, pending: true, error: null } };
    case REQUEST_CONTACT_SUCCESS:
      return {
        ...state,
        requestContact: { ...state.requestContact, succeeded: true, pending: false, response: action.payload.data },
      };
    case REQUEST_CONTACT_FAILURE:
      return {
        ...state,
        requestContact: {
          ...state.requestContact,
          succeeded: false,
          pending: false,
          error: action.payload.error || action.payload,
        },
      };
    case REQUEST_CONTACT_RESET:
      return {
        ...state,
        requestContact: initialState.requestContact,
      };
    case SOCKET_CONNECT_SUCCESS:
      return subreducers({ ...state, anonymous: { ...state.anonymous, reply: action.payload.anonymous } }, action);
    case SOCKET_CONNECT_ANONYMOUS:
      return subreducers({ ...state, isAnonymous: true, anonymous: action.payload }, action);
    case SOCKET_DISCONNECT:
      return subreducers(state, action);
    case SOCKET_EVENT:
      return handleSocketEvents(state, action);
    case SET_CUSTOMER_CHAT:
      return {
        ...state,
        customerChat: { ...state.customerChat, customerVideoCall: null, ...action.payload },
        contact: {
          ...state.contact,
          list: state.contact.list.map(item =>
            item.id === action.payload.currentAgent
              ? {
                  ...item,
                  customer_chat_id: action.payload.customerChat,
                }
              : item
          ),
        },
      };
    case INITIATE_REVIEW:
      return { ...state, reviewData: action.payload };
    case FINISH_REVIEW:
      return { ...state, reviewData: null };
    case SEND_REVIEW:
      return { ...state, reviewPending: true };
    case SEND_REVIEW_SUCCESS:
      return { ...state, reviewPending: false };
    case SEND_REVIEW_FAILURE:
      return { ...state, reviewPending: false, reviewError: action.payload.error };
  }
  return subreducers(state, action);
};
